export default {"src":"/_next/static/media/lifetime.fe4c57ad.svg","height":30,"width":30};